// this file is generated by build-rarity.js
export default {
  "iron": [
    0,
    32,
    65,
    100,
    135,
    172,
    211,
    250,
    291,
    333,
    418,
    506,
    598,
    693,
    791,
    893,
    998,
    1106,
    1218,
    1333,
    1503,
    1679,
    1862,
    2052,
    2249,
    2452,
    2662,
    2879,
    3103,
    3333
  ],
  "bronze": [
    0,
    35,
    72,
    110,
    149,
    189,
    232,
    275,
    320,
    366,
    460,
    557,
    658,
    762,
    870,
    982,
    1098,
    1217,
    1340,
    1466,
    1653,
    1847,
    2048,
    2257,
    2474,
    2697,
    2928,
    3167,
    3413,
    3666,
    3978,
    4301,
    4637,
    4984,
    5345,
    5718,
    6103,
    6501,
    6910,
    7334
  ],
  "silver": [
    0,
    38,
    78,
    120,
    162,
    206,
    253,
    300,
    349,
    400,
    502,
    607,
    718,
    832,
    949,
    1072,
    1198,
    1327,
    1462,
    1600,
    1804,
    2015,
    2234,
    2462,
    2699,
    2942,
    3194,
    3455,
    3724,
    4000,
    4339,
    4692,
    5058,
    5437,
    5831,
    6238,
    6658,
    7092,
    7538,
    8000,
    8678,
    9383,
    10115,
    10874,
    11662,
    12474,
    13315,
    14183,
    15078,
    16000,
    17017,
    18074,
    19172,
    20312,
    21492
  ],
  "gold": [
    0,
    42,
    85,
    130,
    176,
    224,
    274,
    325,
    378,
    433,
    543,
    658,
    777,
    901,
    1028,
    1161,
    1297,
    1438,
    1583,
    1733,
    1954,
    2183,
    2421,
    2668,
    2924,
    3188,
    3461,
    3743,
    4034,
    4333,
    4701,
    5083,
    5480,
    5890,
    6317,
    6757,
    7212,
    7683,
    8167,
    8667,
    9402,
    10165,
    10958,
    11781,
    12633,
    13514,
    14425,
    15365,
    16335,
    17333,
    18435,
    19581,
    20770,
    22005,
    23283,
    24605,
    25970,
    27381,
    28835,
    30333,
    31802,
    33329,
    34917,
    36561,
    38266,
    40028,
    41850,
    43729,
    45669,
    47667,
    49503,
    51412,
    53395,
    55452,
    57582,
    59786,
    62062,
    64412,
    66836,
    69333,
    71904,
    74577,
    77354,
    80233,
    83214,
    86299,
    89487,
    92777,
    96170,
    99667,
    102237,
    104911,
    107687,
    110566,
    113549,
    116633,
    119820,
    123111,
    126504
  ],
  "platinum": [
    0,
    45,
    91,
    140,
    189,
    241,
    295,
    350,
    407,
    466,
    585,
    708,
    837,
    970,
    1107,
    1250,
    1397,
    1548,
    1705,
    1866,
    2104,
    2351,
    2607,
    2873,
    3149,
    3433,
    3727,
    4031,
    4344,
    4666,
    5062,
    5474,
    5901,
    6343,
    6803,
    7277,
    7767,
    8274,
    8795,
    9334,
    10125,
    10947,
    11801,
    12687,
    13605,
    14553,
    15534,
    16547,
    17591,
    18666,
    19853,
    21087,
    22368,
    23698,
    25074,
    26498,
    27968,
    29487,
    31053,
    32666,
    34248,
    35893,
    37603,
    39374,
    41209,
    43107,
    45069,
    47093,
    49182,
    51334,
    53311,
    55367,
    57502,
    59717,
    62012,
    64385,
    66836,
    69367,
    71977,
    74666,
    77435,
    80314,
    83304,
    86405,
    89615,
    92938,
    96370,
    99914,
    103568,
    107334,
    110102,
    112981,
    115970,
    119071,
    122283,
    125605,
    129037,
    132581,
    136235
  ],
  "black": [
    0,
    48,
    98,
    150,
    203,
    258,
    317,
    375,
    437,
    500,
    627,
    759,
    897,
    1040,
    1187,
    1340,
    1497,
    1659,
    1827,
    2000,
    2255,
    2519,
    2793,
    3078,
    3374,
    3678,
    3993,
    4319,
    4655,
    5000,
    5424,
    5865,
    6323,
    6797,
    7289,
    7797,
    8322,
    8865,
    9423,
    10001,
    10848,
    11729,
    12644,
    13593,
    14577,
    15593,
    16644,
    17729,
    18848,
    20000,
    21272,
    22593,
    23966,
    25391,
    26865,
    28391,
    29966,
    31593,
    33272,
    35000,
    36695,
    38457,
    40289,
    42186,
    44153,
    46187,
    48288,
    50457,
    52695,
    55001,
    57119,
    59322,
    61610,
    63983,
    66441,
    68984,
    71610,
    74322,
    77118,
    80000,
    82967,
    86051,
    89255,
    92577,
    96017,
    99576,
    103254,
    107051,
    110966,
    115001,
    117966,
    121052,
    124254,
    127577,
    131018,
    134577,
    138254,
    142052,
    145967
  ]
};
